// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    //dev

    // test
    production: false,
    errorTrackingUrl: 'https://centralized-logging-system-two.vercel.app',
    baseApiUrl: 'https://app-fusionsuite.localdevspace.link/local-gateway/app-identity/', //V2 Dev URL for Authentication
    CCM_API_URL:
        'https://app-fusionsuite.localdevspace.link/local-gateway/customer-complain-managment-service/',
    CCM_REDIRECT_URL: "https://app-fusionsuite.localdevspace.link/ccm/",
    workspaceApiUrl: 'https://app-fusionsuite.localdevspace.link/local-gateway/app-services/', //V2 Dev URL for Workspace
    webSiteURL: 'https://fusionsuite.io/',
    FUSION_WEB_URL: 'https://app-fusionsuite.localdevspace.link/',
    downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    stripePublishKey:
        'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',


    firebase: {
        apiKey: "AIzaSyDFWnPAm9Q_XwtgnMLESWURrv3epHc9NXA",
        authDomain: "testproject-c52e0.firebaseapp.com",
        projectId: "testproject-c52e0",
        storageBucket: "testproject-c52e0.firebasestorage.app",
        messagingSenderId: "204884343975",
        appId: "1:204884343975:web:b1957703cba42f370cef82",
        measurementId: "G-STVE7QR2WD"
    },

    vapidKey: "BEJLJJRzK9DjQ6CztW0HGZUC4Aj_0gvFJNGfaeUGR0AxXyCK2zY_sl5I7ckR0JH4gWkTuqclNB-gVJDwTEFkInE",

    // New onboarding flow (src/app/epics/onboarding) — additive, structural-pass placeholders.
    onboarding: {
        setupProjectRequiresToken: false,
        socialAuth: {
            googleClientId: '',
            appleClientId: '',
            appleRedirectUri: '',
        },
    },

    // Rollout switch for the new onboarding app (core/services/shared-session/new-onboarding-redirect.ts).
    // enabled: sign-in/logout go to appUrl's /login; disabled: this app's own /account/signin.
    // On only when running on localhost: this file is also the deployed dev build's config
    // (ng build -c development), and the onboarding app isn't deployed there yet.
    newOnboarding: {
        enabled: false,
        appUrl: 'http://localhost:4201/',
    },

    // Cross-app login session (see core/services/shared-session/). Must match fusion-onboarding.
    sharedSession: {
        cookieName: 'fusion_session',
        // Empty = host-only cookie. On localhost that is still shared by every port (4200, 4201, ...).
        cookieDomain: '',
        maxAgeDays: 30,
    },

    // 2FA Dev Envirnoment
    // baseApiUrl:
    //     'https://fusion2fa.localdevspace.link/local-gateway/app-identity/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://fusion2fa.localdevspace.link/local-gateway/customer-complain-managment-service/',
    // workspaceApiUrl:
    //     'https://fusion2fa.localdevspace.link/local-gateway/app-services/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://fusion2fa.localdevspace.link/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',

    // baseApiUrl: 'https://securelink.localdevspace.link/local-gateway/app-identity/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://securelink.localdevspace.link/local-gateway/customer-complain-managment-service/',
    // workspaceApiUrl: 'https://securelink.localdevspace.link/local-gateway/app-services/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://securelink.localdevspace.link/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',

    // 2FA Dev Envirnoment
    //   baseApiUrl: 'http://192.168.18.107/local-gateway/app-identity/', //V2 Dev URL for Authentication
    //   CCM_API_URL:
    //     'http://192.168.18.107/local-gateway/customer-complain-managment-service/',
    //   workspaceApiUrl: 'http://192.168.18.107/local-gateway/app-services/', //V2 Dev URL for Workspace
    //   webSiteURL: 'https://fusion2fa.localdevspace.link/',
    //   downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    //   notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    //   stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',





    // baseApiUrl: 'https://identity.cloudstaging.fu8e.space/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://fappservices.cloudstaging.fu8e.space/customer-complain-managment-service/',
    // workspaceApiUrl: 'https://fappservices.cloudstaging.fu8e.space/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://staging.fu8e.space',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',

    //behzad testing envirnoment

    //   baseApiUrl: 'http://52.25.13.27:8005/', //V2 Dev URL for Authentication
    //   CCM_API_URL: 'http://52.25.13.27:8009/',
    //   workspaceApiUrl: 'http://52.25.13.27:8006/', //V2 Dev URL for Workspace
    //   webSiteURL: 'https://fu8e.space/',
    //   downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    //   notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    //Commting on request of Shehroz
    //   stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',

    // stripePublishKey:
    //   'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',

    // Prod
    // , baseApiUrl: 'https://identity.fusionsuite.net/', //V2 Production URL for Authentication,
    // CCM_API_URL:
    //     'https://identity.fusionsuite.net/customer-complain-managment-service/',
    // workspaceApiUrl: 'https://fappservices.fusionsuite.net/', //V2 Production URL for Workspace
    // CCM_REDIRECT_URL: "https://ccm.fusionsuite.localdevspace.link/",
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    // webSiteURL: 'https://app.fusionsuite.net/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',

    // secure link

    // baseApiUrl: 'https://securelink.localdevspace.link/local-gateway/app-identity/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://securelink.localdevspace.link/local-gateway/customer-complain-managment-service/',
    // workspaceApiUrl: 'https://securelink.localdevspace.link/local-gateway/app-services/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://securelink.localdevspace.link/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',


    //   staging
    // ,
    // baseApiUrl:
    //     'https://cloudstaging-apis-identity.sign-secure.link/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://cloudstaging-ccmapp.sign-secure.link/',
    // workspaceApiUrl:
    //     'https://cloudstaging-fappservices.sign-secure.link/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://funky-toad-evolved.ngrok-free.app/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://cloudstaging-puchcenter.sign-secure.link/',
    // CCM_REDIRECT_URL: "https://ccm.cloudstaging-fusionapp.sign-secure.link/",
    // FUSION_WEB_URL: 'https://cloudstaging-fusionapp.sign-secure.link/',
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',


    //   staging 
    // baseApiUrl: 'http://192.168.18.245:8005/',
    // CCM_API_URL: 'http://192.168.18.245:8009/',
    // workspaceApiUrl: 'http://192.168.18.245:8006/',
    // webSiteURL: 'https://funky-toad-evolved.ngrok-free.app/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // stripePublishKey:
    //   'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    // Test Environment 1
    //   baseApiUrl: 'https://staging.fu8e.space/app-identity/', //V2 Dev URL for Authentication
    //   CCM_API_URL:
    //     'https://staging.fu8e.space/customer-complain-managment-service/',
    //   workspaceApiUrl: 'https://staging.fu8e.space/app-services/', //V2 Dev URL for Workspace
    //   webSiteURL: 'https://staging.fu8e.space',
    //   downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    //   stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    // Stagging

    //   stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',

    // Test Environment 2
    //   baseApiUrl: 'https://10.0.0.240/app-identity/', //V2 Dev URL for Authentication
    //   CCM_API_URL: 'https://10.0.0.240/customer-complain-managment-service/',
    //   workspaceApiUrl: 'https://10.0.0.240/app-services/', //V2 Dev URL for Workspace
    //   webSiteURL: 'https://10.0.0.240/',
    //   downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    //   stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    // Test Environment 3
    //   baseApiUrl: 'https://115.186.145.231/app-identity/', //V2 Dev URL for Authentication
    //   CCM_API_URL: 'https://115.186.145.231/customer-complain-managment-service/',
    //   workspaceApiUrl: 'https://115.186.145.231/app-services/', //V2 Dev URL for Workspace
    //   webSiteURL: 'https://115.186.145.231/',
    //   downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    //   stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
};

/*
 * For easier debugging in development mode, you can import the following filex
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
